import { BenefitSplitLimits } from '@my-account/const';
import { StateUtils } from '@spartacus/core';
import { BENEFIT_SPLIT_LIMITS } from '../my-account-state';

export const LOAD_BENEFIT_SPLIT_LIMITS = '[MyAccount] Load Benefit Split Limits';
export const LOAD_BENEFIT_SPLIT_LIMITS_SUCCESS = '[MyAccount] Load Benefit Split Limits Success';
export const LOAD_BENEFIT_SPLIT_LIMITS_FAIL = '[MyAccount] Load Benefit Split Limits Fail';
export const LOAD_BENEFIT_SPLIT_LIMITS_RESET = '[MyAccount] Load Benefit Split Limits Reset';

export class LoadBenefitSplitLimits extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_BENEFIT_SPLIT_LIMITS;

  constructor() {
    super(BENEFIT_SPLIT_LIMITS);
  }
}

export class LoadBenefitSplitLimitsSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_BENEFIT_SPLIT_LIMITS_SUCCESS;

  constructor(public payload: BenefitSplitLimits) {
    super(BENEFIT_SPLIT_LIMITS);
  }
}

export class LoadBenefitSplitLimitsFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_BENEFIT_SPLIT_LIMITS_FAIL;

  constructor() {
    super(BENEFIT_SPLIT_LIMITS);
  }
}

export class LoadBenefitSplitLimitsReset extends StateUtils.LoaderResetAction {
  readonly type = LOAD_BENEFIT_SPLIT_LIMITS_RESET;

  constructor() {
    super(BENEFIT_SPLIT_LIMITS);
  }
}

export type BenefitSplitLimitsActions =
  | LoadBenefitSplitLimits
  | LoadBenefitSplitLimitsSuccess
  | LoadBenefitSplitLimitsFail
  | LoadBenefitSplitLimitsReset;
